import { Outlet, createFileRoute } from "@tanstack/react-router";
import { AuthGate } from "@/auth/AuthGate";
import { useAffiliateSelection } from "@/auth/affiliateSelection";
import { CurrentUserProvider } from "@/currentUser/CurrentUserProvider";
import { RequireConfiguredUser } from "@/currentUser/RequireConfiguredUser";
import { AppShell } from "@/shell/AppShell";
// Pathless layout route: everything nested under it is only reachable by an
// authenticated user. The guard lives in AuthGate, which redirects anonymous
// visitors to Keycloak and shows a loading state until the session resolves.
// Inside the gate, CurrentUserProvider loads the profile once and exposes it
// (with permissions) to every protected page as typed context. A user without
// any permission gets a standalone "not configured" screen instead of the shell.
export const Route = createFileRoute("/_authenticated")({
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  // Read the active tenant from the context that owns the selection, so the
  // profile query re-keys as soon as the user switches.
  const { affiliateId } = useAffiliateSelection();

  return (
    <AuthGate>
      <CurrentUserProvider affiliateId={affiliateId}>
        <RequireConfiguredUser>
          <AppShell>
            <Outlet />
          </AppShell>
        </RequireConfiguredUser>
      </CurrentUserProvider>
    </AuthGate>
  );
}
